/* Add daily and weekly reminders Oct 17, 2026 */
<template lang="pug">
	div(class="kt-reminders")
		div(class="header") 
			fa-icon(:icon="['far', 'bell']")
			span Reminders
		//- Loading
		kt-spinner(v-if="d_loading" p_txt="Reminders")
		div(v-else-if="d_usrRmd.rmdCnt==0" class="py-3 text-center") You currently have no reminders
		div(v-else)
			div(v-for="(rmd, ix) in d_usrRmd.reminders" :key="ix" class="item" v-if="!rmd.dismissed && rmd.daysB4>=0")
				div(v-if="['daily','weekly'].includes(rmd.prntType)")
					div(class="html-message" v-html="rmd.htmlMessage")
				div(v-else class="items")
					fa-layers()
						fa-icon(:icon="['far', 'calendar']")
						fa-layers-text(transform="down-4.5" :value="rmd.daysB4" v-if="rmd.daysB4!==null")
					div
						div
							span {{m_recTypeLabel(rmd)}} 
							span(v-if="rmd.prntType"  class="btn btn-link" @click="m_view(rmd)") {{rmd.name}}
							span(v-else class="btn btn-link" @click="m_view(rmd)") {{m_recLabel(rmd)}}
							span {{m_dateLabel(rmd)}}
						span(class="btn btn-link" @click="m_dismiss(rmd)") Dismiss
		
</template>

<script>

import {fn_dismissReminder} from "@/utils/api.js";
import util, {kbdpRecord} from "@/utils/util.js";
import {fn_appEnt, userReminders} from "@/utils/ref-data.js";

export default {
	name: "kt-reminders",
	components: {},
	beforeCreate() {
		userReminders.fn_reCheck(0); //Rechecks when going to main page or clicking reminder button
	},
	created() {},
	data() {
		return {
			d_loading: null,
			d_usrRmd: userReminders,
			d_today: new Date(new Date().toLocaleDateString())
		};
	},
	props: {
	},
	computed: {
	},
	methods: {
		m_recTypeLabel(rmd) {
			return fn_appEnt(rmd.recType || 'task', rmd.prntType || null).Name;
		},
		m_recLabel(rmd) {
			let rec = (userReminders.refData[rmd.recType] || []).filter(x => x.id == rmd.id)[0];
			if (!rec) return '???';
			return util.fn_recLbl(rec.num, rec.name) || rmd.id;
		},
		m_dateLabel(rmd) {
			let dt = util.fn_fmtDt(rmd.dueDate || rmd.siteWTD);
			let db4 = rmd.daysB4 = util.fn_dateDiff(dt, null);
			let dueTxt1 = rmd.dueDate ? ' is due ' : rmd.siteWTD ? ' has site walk through' : ' ??? ';
			let dueTxt2 = db4 == 0 ? 'Today' : ' in ' + db4 + ' day';
			return dueTxt1 + dueTxt2 + (db4 > 1 ? 's ' : '') + ` (${dt}) `;
		},
		m_dismiss(rmd) {
			let context = rmd.prntType ? fn_appEnt('task', rmd.prntType) : fn_appEnt(rmd.recType);
			let params = {
				recordId: rmd.id,
				triggerKey: rmd.siteWTD ? 'opprSWTD' : null,
			};
			fn_dismissReminder(context.idKey, params).then(resp => {
				if (!resp.error || !resp.errorMessage) {
					rmd.dismissed = true;

					this.d_usrRmd.rmdCnt -= 1;
				}
			});
		},
		m_view(rmd) {
			if (rmd.recType == 'task') {
				kbdpRecord.showTask(rmd.prntType, rmd.id);
			}
			else {
				let rec = (userReminders.refData[rmd.recType] || []).filter(x => x.id == rmd.id)[0];
				if (rec) kbdpRecord.showRecord(rmd.recType, rec.num);
			}

			// console.log(rmd);
		}

	}
};

</script>

<style lang="less">
div.kt-reminders {
	div.header {
		text-align: center;
		padding: 0.2em 0.4em;
		border-bottom: solid 0.15em #adb5bd;
		> svg {
			margin-right: 0.5em;
		}
	}
	> div.items {
		overflow-y: auto;
		max-height: 300px;
		padding: 0.4em 0;
		div.item {
			font-size: 0.9em;
			text-align: left;
			padding: 0.2em 0.4em;
			border-bottom: solid 0.1em #dee2e6;
			display: flex;
			> div.fa-layers {
				margin: auto 0;
				margin-right: 0.5em;
				flex-shrink: 0;

				> svg {
					font-size: 1.2em;
				}
				> span.fa-layers-text {
					font-size: 0.6em;
				}
			}
			> div:nth-child(2) {
				display: flex;
				flex-grow: 1;
				text-align: left;

				span {
					font-size: 1em;
					padding: 0;
					line-height: 1em;
					display: inline;
					margin: auto 0;
				}
				span.btn {
					font-size: 1em;
					vertical-align: unset;
				}
				div:first-child {
					flex-grow: 1;
					padding-right: 0.4em;
				}
			}
			&:hover {
				background-color: #f8f9fa;
			}
		}
	}
}
.html-message {border:none;}
</style>